import React, { useCallback, useMemo, useRef, useState } from "react";
import TicketPopupContext from "./TicketPopupContext";
import TicketPopupWindow from "../../components/TicketPopupWindow";

export { useTicketPopup } from "./TicketPopupContext";

export const TicketPopupProvider = ({ children }) => {
  const [popups, setPopups] = useState([]);
  const zRef = useRef(1600);

  const focusPopup = useCallback((uuid) => {
    if (!uuid) return;
    setPopups((prev) => {
      const nextZ = zRef.current + 1;
      zRef.current = nextZ;
      return prev.map((p) => (p.uuid === uuid ? { ...p, z: nextZ } : p));
    });
  }, []);

  const closePopup = useCallback((uuid) => {
    setPopups((prev) => prev.filter((p) => p.uuid !== uuid));
  }, []);

  const openPopup = useCallback((ticket) => {
    const uuid = ticket?.uuid;
    if (!uuid) return;
    setPopups((prev) => {
      const existing = prev.find((p) => p.uuid === uuid);
      const nextZ = zRef.current + 1;
      zRef.current = nextZ;
      if (existing) {
        return prev.map((p) => (p.uuid === uuid ? { ...p, z: nextZ } : p));
      }
      const offset = prev.length * 28;
      return [
        ...prev,
        {
          uuid,
          id: ticket.id,
          name: ticket.contact?.name || `#${ticket.id}`,
          x: 72 + offset,
          y: 72 + offset,
          z: nextZ,
          width: 420,
          height: 480,
        },
      ];
    });
  }, []);

  const value = useMemo(
    () => ({ openPopup, closePopup, focusPopup }),
    [openPopup, closePopup, focusPopup]
  );

  return (
    <TicketPopupContext.Provider value={value}>
      {children}
      {popups.map((popup) => (
        <TicketPopupWindow
          key={popup.uuid}
          popup={popup}
          onClose={() => closePopup(popup.uuid)}
          onFocus={() => focusPopup(popup.uuid)}
        />
      ))}
    </TicketPopupContext.Provider>
  );
};

export default TicketPopupProvider;
